import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_materials_grid",
  "use": "lc_materials_grid-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_materials_grid\"><path d=\"M320 320H128V128h192v192z m288-192H416v192h192V128z m288 0H704v192h192V128zM320 416H128v192h192V416z m288 0H416v192h192V416z m288 0H704v192h192V416zM320 704H128v192h192V704z m288 0H416v192h192V704z m288 0H704v192h192V704z\" p-id=\"3317\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol